export default "__VITE_ASSET__3d4a743d__"